import { httpClient } from "@/app/client/httpClient";

class TrainingService {
  fetchTraining(id: string) {
    return httpClient.educations.trainings._id(id).get();
  }
  finishTraining(id: string, officeId: number) {
    return httpClient.educations.trainings._id(id).finish.$post({
      body: {
        office_id: officeId
      }
    });
  }
  searchNotFinishedTraining(applicationId: number) {
    return httpClient.educations.trainings.search_not_finished.$get({
      query: {
        application_id: applicationId
      }
    });
  }
}

export const trainingService = new TrainingService();
